import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { getLocalization } from "../../api/localizationApi";

const initialState = {
  dictionary: {},
};

export const fetchLocalization = createAsyncThunk(
  "localization/fetchLocalization",
  async function (_, { rejectWithValue, getState }) {
    try {
      const lang = getState().settings.lang;
      const response = await getLocalization({
        lang,
      });
      return response || {};
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

export const localizationSlice = createSlice({
  name: "localization",
  initialState,
  reducers: {},
  extraReducers: {
    [fetchLocalization.fulfilled]: (state, action) => {
      state.dictionary = action.payload;
    },
    [fetchLocalization.rejected]: (state, action) => {
      throw new Error(action.payload);
    },
  },
});

export const {} = localizationSlice.actions;

export default localizationSlice.reducer;
